import {
    SET_SOURCECURRENCY,
    SET_TARGETCURRENCY,
    SET_ORDERIDS,
    SET_ORDERS,
    SET_TIME,
    SET_TOTALSOURCEAMOUNT,
    SET_TOTALCONVERTEDAMOUNT,
    SET_TOTALTARGETAMOUNT,
    SET_TOTALREMITFEES,
    SET_REMAININGTIME,
    SET_MODALVISIBLE,
    LOCKEXCHANGERATE_REQUEST,
    LOCKEXCHANGERATE_SUCCESS,
    LOCKEXCHANGERATE_FAILURE,
    UPDATEEXCHANGERATE_REQUEST,
    UPDATEEXCHANGERATE_SUCCESS,
    UPDATEEXCHANGERATE_FAILURE, UPDATEEXCHANGERATE_CLEAN_ERROR, UPDATEEXCHANGERATE_CLEAN_SUCCESS,
} from "./bulkFxUpdateType";

import {
    lockExchangeRate, doChangeFxRateApi
} from "../../api/api";
  
  
export const setSourceCurrency = (sourceCurrency) => {
    return {
        type: SET_SOURCECURRENCY,
        sourceCurrency: sourceCurrency,
    };
};

export const setTargetCurrency = (targetCurrency) => {
    return {
        type: SET_TARGETCURRENCY,
        targetCurrency: targetCurrency,
    };
};

export const setOrderIds = (orderIds) => {
    return {
        type: SET_ORDERIDS,
        orderIds: orderIds,
    };
};

export const setOrders = (orders) => {
    return {
        type: SET_ORDERS,
        orders: orders,
    };
};

export const setTime = (time) => {
    return {
        type: SET_TIME,
        time: time,
    };
};

export const setTotalSourceAmount = (totalSourceAmount) => {
    return {
        type: SET_TOTALSOURCEAMOUNT,
        totalSourceAmount: totalSourceAmount,
    };
};

export const setTotalConvertedAmount = (totalConvertedAmount) => {
    return {
        type: SET_TOTALCONVERTEDAMOUNT,
        totalConvertedAmount: totalConvertedAmount,
    };
};

export const setTotalTargetAmount = (totalTargetAmount) => {
    return {
        type: SET_TOTALTARGETAMOUNT,
        totalTargetAmount: totalTargetAmount,
    };
};

export const setTotalRemitFees = (totalRemitFees) => {
    return {
        type: SET_TOTALREMITFEES,
        totalRemitFees: totalRemitFees,
    };
};

export const setRemainingTime = (remainingTime) => {
    return {
        type: SET_REMAININGTIME,
        remainingTime: remainingTime,
    };
};

export const setModalVisible = (modalVisible) => {
    return {
        type: SET_MODALVISIBLE,
        modalVisible: modalVisible,
    };
};
  
const lockExchangeRateRequest = () => {
    return {
        type: LOCKEXCHANGERATE_REQUEST,
    };
};
  
const lockExchangeRateSuccess = (payload) => {
    return {
        type: LOCKEXCHANGERATE_SUCCESS,
        payload: payload,
    };
};
  
const lockExchangeRateFailure = (error) => {
    return {
        type: LOCKEXCHANGERATE_FAILURE,
        payload: error,
    };
};

export const callLockExchangeRate = (sourceCurrency, targetCurrency, requestedAmount) => {
    return async (dispatch) => {
        dispatch(lockExchangeRateRequest());
        try {
            var response = await lockExchangeRate(sourceCurrency, targetCurrency, requestedAmount);
            // return data
            dispatch(lockExchangeRateSuccess(response));
        } catch (error) {
            dispatch(lockExchangeRateFailure(error.message));
        }
    };
};

const updateExchangeRateRequest = () => {
    return {
        type: UPDATEEXCHANGERATE_REQUEST,
    };
};
  
const updateExchangeRateSuccess = (payload) => {
    return {
        type: UPDATEEXCHANGERATE_SUCCESS,
        payload: payload,
    };
};
  
const updateExchangeRateFailure = (error) => {
    return {
        type: UPDATEEXCHANGERATE_FAILURE,
        payload: error,
    };
};

export const callUpdateExchangeRate = (orders, newExchangeRate) => {
    for (var i=0; i<orders.length; i++) {
        orders[i].newExchangeRate = newExchangeRate;
    }
    let result = async (dispatch) => {
        dispatch(updateExchangeRateRequest());
        try {
            await doChangeFxRateApi(orders).then(response => {
                dispatch(updateExchangeRateSuccess(response));
            }).catch(e => {
                console.log(e)
                dispatch({ type: UPDATEEXCHANGERATE_FAILURE,
                    payload: e.result});
            });

            // return data
            // dispatch(updateExchangeRateSuccess(response));
        } catch (error) {
            dispatch(updateExchangeRateFailure(error));
        }
    };
    return result;
};

export const cleanError = () => {
    return {
        type: UPDATEEXCHANGERATE_CLEAN_ERROR,
    }
}

export const cleanSuccess = () => {
    return {
        type: UPDATEEXCHANGERATE_CLEAN_SUCCESS,
    }
}
